import { render } from "./Eceran.vue?vue&type=template&id=3464ee83&scoped=true"
import script from "./Eceran.vue?vue&type=script&lang=js"
export * from "./Eceran.vue?vue&type=script&lang=js"

import "./Eceran.vue?vue&type=style&index=0&id=3464ee83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3464ee83"]])

export default __exports__